import axios from "axios";
import { getSession } from "../Utils/SessionUtils";

const api_url = process.env.REACT_APP_API;

// Helper function to get dynamic config with current token
const getConfig = () => {
  const token = getSession("token");
  console.log(
    "Current token in getConfig:",
    token ? "Token exists" : "No token"
  );

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

//to add in every api
const currentOrg = getSession("usedorganisations");

export async function getParametrageCaisse(organisationId = null) {
  const orgId = organisationId || currentOrg;

  try {
    const response = await axios.get(
      api_url + `parametrage/${orgId}`,
      getConfig()
    );
    return response;
  } catch (error) {
    console.error("Error fetching cash parametrage:", error);
    throw error;
  }
}
export async function updateParametragesCaisse(id, data) {
  try {
    const response = await axios.put(
      api_url + `parametrage/${id}`,
      data,
      getConfig()
    );
    return response;
  } catch (error) {
    console.error("Error fetching cash parametrage:", error);
    throw error;
  }
}
export async function createParametrageCaisse(data) {
  try {
    const response = await axios.post(
      api_url + `parametrage`,
      data,
      getConfig()
    );
    return response;
  } catch (error) {
    console.error("Error fetching cash parametrage:", error);
    throw error;
  }
}
